export enum AuthState {
  disconnected,
  authorized,
}
